import React from "react";

const Headlinebox = () => {
  return (
    <div className="maincontainer relative overflow-x-clip pb-20 sm:pb-2">
      <div className="container sm:container mx-auto md:container md:auto">
        <div className="headlinesboix lg:pt-5 lg:pb-10  flex justify-center">
          <div className="biglines  mt-10">
            <h1 className="fonting mx-auto max-w-5xl font-display text-4xl font-medium tracking-tight text-slate-900 sm:text-5xl">
              Our Packages
            </h1>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Headlinebox;
